import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

import {availableDishesService} from "../../../services/menu-services/availableDishes.service";


const initialState = {
    availableDishesArray: [],
    availableDishesArrayFiltered: [],
    dataOfDay: null,
    status: null,
    error: null,
    trigger: 0,
}


const getAllAvailableDishes = createAsyncThunk(
    'availableDishesSlice/getAllAvailableDishes',
    async ({currentData, bypass = false}, {rejectWithValue}) => {
        try {
            return await availableDishesService.getAllSAvailableDishes(currentData, bypass);
        } catch (e) {
            return rejectWithValue(e.response?.data?.message || "Something went wrong");
        }
    }
);


const availableDishesSlice = createSlice({
    name: "availableDishesSlice",
    initialState,
    reducers: {
        changeTrigger: (state, action) => {
            state.trigger = state.trigger + 1;
        },
        // changeDataOfDay: (state, action) => {
        //     state.dataOfDay = action.payload;
        // },

        changeDataOfDay: (state, action) => {
            state.dataOfDay = action.payload;
            localStorage.setItem('availableDishesSelectedDate', action.payload);
        },
        filteredDishes: (state, action) => {
            const name = action.payload?.toLowerCase();

            if (name) {
                state.availableDishesArrayFiltered = state.availableDishesArray.filter((obj) =>
                    obj.dish?.name?.en?.toLowerCase().includes(name) ||
                    obj.dish?.name?.ru?.toLowerCase().includes(name) ||
                    obj.dish?.name?.ge?.toLowerCase().includes(name)
                );
            } else {
                state.availableDishesArrayFiltered = [...state.availableDishesArray];
            }
        },
        clearSearch: (state) => {
            state.availableDishesArrayFiltered = [];
        },
    },
    extraReducers: builder =>
        builder
            .addCase(getAllAvailableDishes.pending, state => {
                state.status = 'Loading';
                state.error = null;
            })
            .addCase(getAllAvailableDishes.fulfilled, (state, action) => {
                state.status = 'fulfilled';
                state.availableDishesArray = action.payload;
            })
            .addCase(getAllAvailableDishes.rejected, (state, action) => {
                state.status = 'rejected';
                state.error = action.payload;
            })
});

const {reducer: availableDishesReducer, actions} = availableDishesSlice;
const availableDishesActions = {
    ...actions,
    getAllAvailableDishes
}

export {
    availableDishesActions,
    availableDishesReducer
}